"use client";

import { c as _c } from "react/compiler-runtime";
import { Item, ItemAvatar, ItemContent } from "@opensea/next-ui-kit";
import { Checkbox, classNames, SkeletonBlock, SkeletonLine, TableCell, TableRow, tableRowSizeVariants, useTable } from "@opensea/ui-kit";
import { useContextSelector } from "use-context-selector";
import { CollectionSettingsContext } from "@/components/collection/CollectionSettingsProvider";
import { useSideModule } from "@/components/layout/SideModuleProvider";
import { COLLECTION_ITEMS_TABLE_COLUMN_CLASSNAMES } from "./styles";
export function CollectionItemsTableSkeletonRow() {
  const $ = _c(30);
  const {
    size
  } = useTable();
  const {
    image
  } = tableRowSizeVariants({
    size
  });
  const {
    isSideModuleOpen
  } = useSideModule();
  const showRarity = useContextSelector(CollectionSettingsContext, _temp);
  const T0 = TableRow;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TableCell className={COLLECTION_ITEMS_TABLE_COLUMN_CLASSNAMES.checkbox}><Checkbox /></TableCell>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const T1 = TableCell;
  const t1 = COLLECTION_ITEMS_TABLE_COLUMN_CLASSNAMES;
  const T2 = Item;
  const t2 = "unstyled";
  const T3 = ItemAvatar;
  const t3 = image();
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SkeletonBlock className="rounded-lg" />;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== T3 || $[3] !== t3) {
    t5 = <T3 className={t3}>{t4}</T3>;
    $[2] = T3;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ItemContent><SkeletonLine className="w-1/2" /></ItemContent>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== T2 || $[7] !== t5) {
    t7 = <T2 variant={t2}>{t5}{t6}</T2>;
    $[6] = T2;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== T1 || $[10] !== t1.item || $[11] !== t7) {
    t8 = <T1 className={t1.item}>{t7}</T1>;
    $[9] = T1;
    $[10] = t1.item;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== showRarity) {
    t9 = showRarity ? <TableCell align="right" className={COLLECTION_ITEMS_TABLE_COLUMN_CLASSNAMES.rarity}><SkeletonLine className="w-1/2" /></TableCell> : null;
    $[13] = showRarity;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <TableCell align="right" className={COLLECTION_ITEMS_TABLE_COLUMN_CLASSNAMES.price}><SkeletonLine className="w-1/2" /></TableCell>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <TableCell align="right" className={COLLECTION_ITEMS_TABLE_COLUMN_CLASSNAMES.offer}><SkeletonLine className="w-1/2" /></TableCell>;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== isSideModuleOpen) {
    t12 = classNames(COLLECTION_ITEMS_TABLE_COLUMN_CLASSNAMES.last, {
      hidden: isSideModuleOpen
    });
    $[17] = isSideModuleOpen;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SkeletonLine className="w-1/2" />;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12) {
    t14 = <TableCell align="right" className={t12}>{t13}</TableCell>;
    $[20] = t12;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <TableCell align="right" className={COLLECTION_ITEMS_TABLE_COLUMN_CLASSNAMES.owner}><SkeletonLine className="w-1/2" /></TableCell>;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <TableCell align="right" className={COLLECTION_ITEMS_TABLE_COLUMN_CLASSNAMES.listed}><SkeletonLine className="w-1/2" /></TableCell>;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== T0 || $[25] !== t0 || $[26] !== t14 || $[27] !== t8 || $[28] !== t9) {
    t17 = <T0>{t0}{t8}{t9}{t10}{t11}{t14}{t15}{t16}</T0>;
    $[24] = T0;
    $[25] = t0;
    $[26] = t14;
    $[27] = t8;
    $[28] = t9;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
}
function _temp(state) {
  return state.showRarity;
}